import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=f08cdbd2&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=ts&"
export * from "./Options.vue?vue&type=script&lang=ts&"
import style0 from "./Options.vue?vue&type=style&index=0&id=f08cdbd2&scoped=true&lang=css&"
import style1 from "./Options.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08cdbd2",
  null
  
)

export default component.exports